<template>
  <MainLayout />
</template>

<script>
import MainLayout from "./layouts/MainLayout.vue";

export default {
  name: "App",
  components: {
    MainLayout
  },
  computed: {
    authUser: function() {
      return this.$user.getters.authUser;
    },
    returnUrl() {
      return this.$route.query.returnUrl;
    }
  },
  created: function() {
    this.$http.interceptors.response.use(undefined, err => {
      return new Promise(() => {
        if (err.toString().includes("403")) {
          this.$user.dispatch("logout").then(() => {
            let returnUrl = this.$router.currentRoute.fullPath;
            let query = returnUrl ? { returnUrl } : null;
            this.$router.push({ name: "Login", query });
          });
          return;
        }
        throw err;
      });
    });
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      let $ = window.jQuery;
      var $scrollTop = $("#scroll-top");
      $(window).on("load scroll", function() {
        if ($(window).scrollTop() >= 400) {
          $scrollTop.addClass("show");
        } else {
          $scrollTop.removeClass("show");
        }
      });

      // On click animate to top
      $scrollTop.on("click", function(e) {
        $("html, body").animate(
          {
            scrollTop: 0
          },
          800
        );
        e.preventDefault();
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue